import { environment } from 'src/environments/environment';
import { PaypalService } from 'src/app/services/paypal.service';
import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';

@Component({
  selector: 'app-paypal-smart-button',
  templateUrl: './paypal-smart-button.component.html',
  styleUrls: ['./paypal-smart-button.component.scss'],
  standalone: true
})
export class PaypalSmartButtonComponent implements OnInit {

  @Input() user_id: string;
  @Input() uuid: string;
  @Input() style: string;
  public URL: string = environment.rootUrl;
  public URL_SERVICES: string = environment.rootServicesUrl;
  public ba_token: string;
  @ViewChild('paypalRef', { static: true }) private paypalRef: ElementRef;
  constructor(
    private paypalService: PaypalService
  ) { }

  ngOnInit(): void {
    paypal.Buttons({
      style: {
        layout: 'horizontal',
        tagline: false,

      },
      createBillingAgreement: async (data: any, actions: any) => {
        this.setScriptSecurityPaypal();
        try {
          const res = await this.paypalService.createBillingAgreementToken(this.uuid);
          this.ba_token = res.token_id;
          return res.token_id;
        } catch (error) { }
      },
      onApprove: () => window.location.href = (`${this.URL}/cart/paypal/billing-agreement/approved/${this.user_id}?ba_token=${this.ba_token}`)
    }).render(this.paypalRef.nativeElement);
  }

  public setScriptSecurityPaypal(): void {
    const scriptFraudNet = document.createElement('script');
    scriptFraudNet.async = true;
    scriptFraudNet.setAttribute('type', 'application/json');
    scriptFraudNet.setAttribute('fncls', environment.fncls);
    const jsonData = {
      f: this.uuid,
      s: environment.sVarRTAccount
    };
    scriptFraudNet.text = `${JSON.stringify(jsonData)}`;
    document.body.appendChild(scriptFraudNet);
    const fbScript = document.createElement('script');
    fbScript.async = true;
    fbScript.setAttribute('type', 'text/javascript');
    fbScript.setAttribute('src', 'https://c.paypal.com/da/r/fb.js');
    document.body.appendChild(fbScript);
  }

}
